import { WebsiteBackground } from '@cineamo/api/models/website-configuration/WebsiteBackground.enum';
import {
    WebsiteBackgroundRepeat,
    WebsiteBackgroundSize
} from '@cineamo/api/models/website-configuration/WebsiteTheme.types';

export type WebsiteBackgroundPreset = {
    /**
     * Public path of the background image in the cinema-website app.
     * The cinema app ships preview copies under `/images/website-backgrounds{imagePath}`.
     */
    imagePath: string;
    backgroundRepeat: WebsiteBackgroundRepeat;
    backgroundSize: WebsiteBackgroundSize;
    /** Opacity of the background image in percent (0-100). */
    backgroundOpacity: number;
    /** CSS `background` rendered behind the image layer. */
    background?: string;
};

export const WEBSITE_BACKGROUND_PRESETS: Partial<Record<WebsiteBackground, WebsiteBackgroundPreset>> = {
    [WebsiteBackground.CARBON]: {
        imagePath: '/bg-carbon.jpg',
        backgroundRepeat: 'repeat',
        backgroundSize: 'auto',
        backgroundOpacity: 15,
        background: 'radial-gradient(#2B2B2B, #121212)'
    },
    [WebsiteBackground.STARS_1]: {
        imagePath: '/kinosommer-villach-background.png',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundOpacity: 15
    },
    [WebsiteBackground.STARS_2]: {
        imagePath: '/traumpalast-background.png',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundOpacity: 15
    },
    [WebsiteBackground.LEAVES]: {
        imagePath: '/prestige-kuenzelsau-background.png',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundOpacity: 25
    }
};

/** Fallback opacity (in percent) for the background image when neither the theme nor a preset defines one. */
export const WEBSITE_BACKGROUND_DEFAULT_OPACITY = 15;
